import React from 'react';
import { Select, useTheme } from 'native-base';
import { useCategoriesState } from '../../../context/categories';
import { useAuthState } from '../../../context/auth';
import { LANGUAGES } from '../../Constants';
const ChooseCategory = _ref => {
  let {
    key,
    selectedPostCategoryId,
    setSelectedPostCategoryId,
    setCategoryObject,
    setIsCategoryValid
  } = _ref;
  const theme = useTheme(),
    {
      colors
    } = theme;
  const categoriesState = useCategoriesState();
  const authState = useAuthState();
  const {
    forumCategories: categories,
    rootForumCategory,
    selectedCategory
  } = categoriesState;
  const {
    moderator
  } = authState;
  let allowedCategories;
  if (categories && categories.length > 0) {
    if (rootForumCategory && moderator) {
      allowedCategories = [{
        ...rootForumCategory,
        name: '(none)'
      }, ...categories];
    } else {
      allowedCategories = categories;
    }
  }
  return allowedCategories ? /*#__PURE__*/React.createElement(Select, {
    accessibilityLabel: 'Choose Category',
    placeholder: LANGUAGES.PLACEHOLDERS.CHOOSE_CATEGORY,
    selectedValue: selectedPostCategoryId,
    _selectedItem: {
      bg: colors.chooseCategory.bg
    },
    key: key,
    onValueChange: itemValue => {
      const itemId = parseInt(itemValue);
      if (itemId) {
        setSelectedPostCategoryId(itemId);
        setIsCategoryValid(true);
        setCategoryObject && setCategoryObject(allowedCategories.filter(c => c.id === itemId)[0]);
      } else {
        setIsCategoryValid(false);
      }
    }
  }, allowedCategories.map(category => /*#__PURE__*/React.createElement(Select.Item, {
    key: category.name + ': ' + category.description,
    label: category.name,
    value: category.id
  }))) : /*#__PURE__*/React.createElement(Text, {
    fontSize: 'xs',
    color: colors.changeCategory.message
  }, "Unable to load categories. Please try again.");
};
export default ChooseCategory;
//# sourceMappingURL=ChooseCategory.js.map